import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import ReportPage from '../pages/Report/ReportPage';
import DteBulkDownloadPage from '../pages/Report/dteBulkDownload/DteBulkDownloadPage';
import NegativeStockReportPage from '../pages/Report/negativeStock/NegativeStockReportPage';
import ProductGroupsPage from '../pages/Report/productGroups/ProductGroupsPage';
import DailyGroupSalesReportPage from '../pages/Report/dailyGroupSales/DailyGroupSalesReportPage';
import TourismTaxReportPage from '../pages/Report/tourismTax/TourismTaxReportPage';
import TipReportPage from '../pages/Report/tip/TipReportPage';
import ProtectedRouteV2 from './ProtectedRouteV2';

const reportRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/reports"
      element={
        <>
          <PageTitle title="Reportes | Sistema de Administración" />
          <ReportPage />
        </>
      }
    />
    <Route
      path="/reports/dte-bulk-download"
      element={
        <>
          <PageTitle title="Descarga masiva DTE | Sistema de Administración" />
          <DteBulkDownloadPage />
        </>
      }
    />
    <Route
      path="/reports/negative-stock"
      element={
        <>
          <PageTitle title="Stock Negativo | Sistema de Administración" />
          <NegativeStockReportPage />
        </>
      }
    />
    <Route
      path="/reports/negative-stock/page/:page"
      element={
        <>
          <PageTitle title="Stock Negativo | Sistema de Administración" />
          <NegativeStockReportPage />
        </>
      }
    />
    <Route
      path="/reports/product-groups"
      element={
        <>
          <PageTitle title="Grupos de Productos | Sistema de Administración" />
          <ProductGroupsPage />
        </>
      }
    />
    <Route
      path="/reports/daily-group-sales"
      element={
        <>
          <PageTitle title="Ventas Diarias por Grupo | Sistema de Administración" />
          <DailyGroupSalesReportPage />
        </>
      }
    />
    <Route
      path="/reports/tourism-tax"
      element={
        <>
          <PageTitle title="Turismo por Alojamiento | Sistema de Administración" />
          <TourismTaxReportPage />
        </>
      }
    />
    <Route
      path="/reports/tips"
      element={
        <>
          <PageTitle title="Propina | Sistema de Administración" />
          <TipReportPage />
        </>
      }
    />
  </Route>
);

export default reportRoutes;
